import type { StateWithModalManager } from './modalManagerSlice'

export const getVisibleModal = (state: StateWithModalManager) =>
    state.modalManager.visibleModals[0]
